import { Denounce } from './../../../core/models/denounce.model';
import { CasesPerGender } from './../../../core/interfaces/interfaces';
import { ComplaintsService } from './../../../core/services/complaints.service';

import { Chart, ChartData, ChartDataSets } from 'chart.js';

import {
	AggressionType,
	AtTime,
	PlaceTypes,
	PerAge,
	PerGender,
} from '../../../core/interfaces/interfaces';

import {
	Component,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges,
} from '@angular/core';
@Component({
	selector: 'app-bar-chart',
	templateUrl: './bar-chart.component.html',
	styleUrls: ['./bar-chart.component.scss'],
})
export class BarChartComponent implements OnInit, OnChanges {
	public casesPerType: AggressionType = {} as AggressionType;
	public casesPerPlace: PlaceTypes = {} as PlaceTypes;
	public casesPerGender: PerGender = {} as PerGender;
	public casesPerTime: AtTime = {} as AtTime;
	public casesPerAge: PerAge = {} as PerAge;
	public value: number = 0;
	public momentoOcorrido:number = 0;
	public momentosPosOcorrido:number = 0;

	@Input() complaints?: Denounce[];
	@Input() from?: Date;
	@Input() to?: Date;

	loading = true;

	// TODO fazer o label ser de acordo com a data no from-to
	private currentYearDate = new Date();
	private currentYear = this.currentYearDate.getFullYear();
	private barChartLabels2 = ['2020 - 2023'];
	@Input() public barChartLabels = [`${this.currentYear - 3} - ${this.currentYear}`];
	private chartDataSets = [];
	private barChartType = 'bar';
	private chart: Chart | null = null;

	public barColors = [
		{
			backgroundColor: [
				'rgba(255, 162, 107, .75)',
				'rgba(92, 53, 100, .75)',
				'rgba(208, 201, 214, .75)',
				'rgba(71, 184, 129, .75)',
				'rgba(247, 209, 84, .75)',
				'rgba(255, 100, 124,.75)',
			],
		},
	];

	constructor(private complaintsService: ComplaintsService) { }

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.from || changes.to) {
			this.getByAge(this.from, this.to);
			this.getByGender(this.from, this.to);
		}

		if (changes.complaints) {
			this.ngOnInit();
		}
	}

	ngOnInit(): void {
		const countType: any = {};
		const countPlace: any = {};
		const countAtTime: any = {};

		this.complaints.forEach((x) => {
			countPlace[x.place] = (countPlace[x.place] || 0) + 1;
			countAtTime[String(x.at_moment)] =
				(countAtTime[String(x.at_moment)] || 0) + 1;

			x.type.forEach((element) => {
				countType[element] = (countType[element] || 0) + 1;
			});
		});

		this.casesPerPlace = countPlace;
		this.casesPerTime = countAtTime;
		this.casesPerType = countType;

		this.getByAge();

	}

	/**
	 * Função responsável por receber a lista de registros por gênero
	 * @param from data de inicio
	 * @param to data final
	 */
	private getByGender(from?: Date, to?: Date): void {
		let requisicao;

		if (from && to) {
			requisicao = this.complaintsService.getAggregations(
				'gender',
				this.from.toJSON().split('T')[0],
				this.to.toJSON().split('T')[0]
			);
		} else {
			requisicao = this.complaintsService.getAggregations('gender');
		}

		requisicao.subscribe((response: CasesPerGender) => {
			for (const [k, v] of Object.entries(response)) {
				this.casesPerGender[k] = v;
			}
		});
	}

	/**
	 * Função responsável por receber a lista de registros por idade
	 * @param from data de inicio
	 * @param to data final
	 */
	private getByAge(from?: Date, to?: Date) {
		const zip = (a, b) => a.map((k, i) => [k, b[i]]);

		let LESS_THAN_20 = 0;
		let LESS_THAN_40 = 0;
		let LESS_THAN_60 = 0;
		let LESS_THAN_80 = 0;

		let requisicao;

		if (from && to) {
			requisicao = this.complaintsService.getAggregations(
				'age',
				this.from.toJSON().split('T')[0],
				this.to.toJSON().split('T')[0]
			);
		} else {
			requisicao = this.complaintsService.getAggregations('age');
		}

		requisicao.subscribe((response: any) => {
			// Response format
			// Example:
			// response = {
			// 	"28": 1,
			// 	"26": 12,
			// 	"30": 1,
			// 	"21": 10,
			// 	"40": 1,
			// 	"undefined": 37
			// }
			const zipped = zip(Object.keys(response), Object.values(response));

			zipped.forEach((element) => {
				if (Number(element[0]) <= 20) {
					LESS_THAN_20 += element[1];
				} else if (Number(element[0]) <= 40) {
					LESS_THAN_40 += element[1];
				} else if (Number(element[0]) <= 60) {
					LESS_THAN_60 += element[1];
				} else if (Number(element[0] >= 60)) {
					LESS_THAN_80 += element[1];
				}
			});

			this.casesPerAge.LESS_20 = LESS_THAN_20;
			this.casesPerAge.LESS_40 = LESS_THAN_40;
			this.casesPerAge.LESS_60 = LESS_THAN_60;
			this.casesPerAge.MORE_61 = LESS_THAN_80;
			this.getByGender();
			this.createDataSets();
			this.createChart();
		});
	}

	createDataSets(): void {

		let dataCasesWithLabel = [
			{
				label: 'Encoxar/apalpar',
				data: this.casesPerType.SELF_TOUCH_OR_FLASHING,
			},
			{
				label: 'Perseguição',
				data: this.casesPerType.STALKING,
			},
			{
				label: 'Intimidação',
				data: this.casesPerType.COERCION,
			},
			{
				label: 'Se tocando ou mostrando',
				data: this.casesPerType.GROPING,
			},
			{
				label: 'Fotos não autorizadas',
				data: this.casesPerType.UNWANTED_PHOTOS,
			},
			{
				label: 'Outros',
				data: this.casesPerType.OTHERS,
			},
		];

		dataCasesWithLabel = dataCasesWithLabel.sort((a, b) => b.data - a.data);

		this.chartDataSets = [
			// SET 1 = Per Type
			[	
				{	
					labels : [dataCasesWithLabel[0].label,dataCasesWithLabel[1].label,dataCasesWithLabel[2].label,dataCasesWithLabel[3].label,dataCasesWithLabel[4].label,dataCasesWithLabel[5].label],

					data:[
						dataCasesWithLabel[0].data,
						dataCasesWithLabel[1].data,
						dataCasesWithLabel[2].data,
						dataCasesWithLabel[3].data,
						dataCasesWithLabel[4].data,
						dataCasesWithLabel[5].data,
					],

					backgroundColor: ['#150A50','#3421A2','#6C56EB','#9A89FC;','#CDC5FF','#83DAC1'],

					type: 'horizontalBar',

				}

			],

			// SET 2 = Per Place
			[	
				{
					labels : ['Ônibus','Parada','Terminal','Outros'],
					data:[this.casesPerPlace.BUS,this.casesPerPlace.BUS_STOP,this.casesPerPlace.BUS_TERMINUS,this.casesPerPlace.OTHER],
					backgroundColor: ['#150A50','#3421A2','#6C56EB','#9A89FC;'],
					type: 'bar',
				}

			],

			// SET 3 = Per Time
			[
				{
					label: 'No momento',
					data: [this.casesPerTime.true],
					backgroundColor: ['rgba(247, 209, 84, .75)'],
				},
				{
					label: 'Após o ocorrido',
					data: [this.casesPerTime.false],
					backgroundColor: ['rgba(208, 201, 214, .75)'],
				},
			],

			// SET 4 = Per Age
			[
				{	
					label: '15 - 20',
					data: [this.casesPerAge.LESS_20 || 0],
					backgroundColor: ['#150A50'],
				},

				{	
					label: '21 - 40',
					data: [this.casesPerAge.LESS_40 || 0],
					backgroundColor: ['#3421A2'],
				},

				{	
					label: '41 - 60',
					data: [this.casesPerAge.LESS_60 || 0],
					backgroundColor: ['#6C56EB'],
				},

				{	
					label: '> 60',
					data: [this.casesPerAge.MORE_61 || 0],
					backgroundColor: ['#9A89FC'],
				}


				
			],

			// SET 5 = Per Gender
			[	
				{
					label: 'Cisgênero',
					data: [
						this.casesPerGender.MAN_CIS !== undefined
							? this.casesPerGender.MAN_CIS
							: 0,
	
						this.casesPerGender.WOMAN_CIS !== undefined
							? this.casesPerGender.WOMAN_CIS
							: 0
					],
					backgroundColor: ['#150A50', '#150A50'],
				},
				{
					label: 'Transgenero',
					data: [
						this.casesPerGender.MAN_TRANS !== undefined
							? this.casesPerGender.MAN_TRANS
							: 0,
						this.casesPerGender.WOMAN_TRANS !== undefined
							? this.casesPerGender.WOMAN_TRANS
							: 0
					],
					backgroundColor: ['#6C56EB', '#6C56EB'],
				},
				{
					label: 'Não Binário',
					data: [0,0,
						this.casesPerGender.NON_BINARY !== undefined
							? this.casesPerGender.NON_BINARY
							: 0,
					],
					backgroundColor: ['#6C56EB','#6C56EB','#6C56EB'],
				},

			],
		];
	}

	createChart(value?): void {
		this.value = value;
		if(value == 2){
			this.momentoOcorrido = Number(this.casesPerTime.true);
			this.momentosPosOcorrido = Number(this.casesPerTime.false);
		}
		setTimeout(() => {
			const canvas = document.getElementById('myHChart') as HTMLCanvasElement;
			const ctx = canvas.getContext('2d');
			const parent = canvas.parentElement;
			const aspectRatio = 1.5; // Proporção de aspecto desejada (ajuste de acordo com suas preferências)
			
			
			let grapyStyle = this.changeGraph(value);
	
			// Atualizar a altura do canvas com base na largura do contêiner pai e na proporção de aspecto
			const chartHeight = parent.clientWidth / aspectRatio;
			canvas.style.height = chartHeight + 'px';
		  
			const chartdata: ChartData = {
			  labels: value ? this.changeGraph(value).labels : this.chartDataSets[0][0].labels,
			  datasets: value ? this.chartDataSets[value] : this.chartDataSets[0],
			};
	
		  
			if (this.chart) {
			  this.chart.destroy();
			}
		  
			this.chart = new Chart(ctx, {
			  type: value ? this.changeGraph(value).type : this.chartDataSets[0][0].type,
			  data: chartdata,
			  options: {
				responsive: true,
				maintainAspectRatio: false, // Desabilitar o ajuste automático do Chart.js
				legend: {
				  display: this.changeGraph(value).legend,
				  position: 'bottom',
				  align: 'start',
				  labels: {
					boxWidth: 16, // Ajustar o tamanho dos quadrados para que sejam exibidos como quadrados perfeitos
					fontSize: 16
				  }
				},
				scales: {
					xAxes: [{
					 
					  gridLines: {
						display: false,
						drawOnChartArea: false,
					  },
					  ticks: {
	
					  },
					}],
					yAxes: [{
	
					}]
				  }
			  },
			});
		  
			this.loading = false;
		},5)
		
	  }

	
	changeGraph(value: string): any {
		let constructorGraph = {}
		if(Number(value) == 0){
			constructorGraph = {
				type: 'horizontalBar',
				labels: this.chartDataSets[0][0].labels,
				legend: false,
			}
		}

		else if (Number(value) == 1){
			constructorGraph = {
				type: 'bar',
				labels: this.chartDataSets[1][0].labels,
				legend: false,
			}
		}

		else if (Number(value) == 3){
			constructorGraph = {

				type: 'bar',
				legend: true,
			}
		}

		else if (Number(value) == 4){
			constructorGraph = {
				type: 'bar',
				labels: ['Homens','Mulheres','Não Binário'],
				legend: true,
			}
		}
		else{
			constructorGraph = {
				type: 'bar',
			}
		}

		return constructorGraph;

	}
	  
	  
}
